import type { MusicPageGroup } from './types';

export type MusicPageLink = {
  /** Slug under /ai-music-generator. */
  id: string;
  /** Link label (a `music-landing` key). */
  name: string;
  group: Exclude<MusicPageGroup, 'main'>;
};

export const MUSIC_HOME_PATH = '/ai-music-generator';

export const musicPagePath = (id: string) =>
  id === 'main' ? MUSIC_HOME_PATH : `${MUSIC_HOME_PATH}/${id}`;

/**
 * Every music landing page under /ai-music-generator, in the order the
 * "Explore" section lists them. The page content lives in ./pages.ts.
 */
export const MUSIC_PAGE_LINKS: MusicPageLink[] = [
  { id: 'ai-songwriter', name: 'AI songwriter', group: 'occasion' },
  { id: 'lyrics-to-song', name: 'Lyrics to song', group: 'occasion' },
  { id: 'rap', name: 'Rap songs', group: 'occasion' },
  { id: 'personalized-song', name: 'Personalized songs', group: 'occasion' },
  { id: 'birthday-song', name: 'Birthday songs', group: 'occasion' },
  { id: 'jingle', name: 'Jingles', group: 'occasion' },
  { id: 'podcast-intro-music', name: 'Podcast intro music', group: 'occasion' },
  { id: '8-bit', name: '8-bit music', group: 'occasion' },

  { id: 'pop', name: 'Pop', group: 'genre' },
  { id: 'rock', name: 'Rock', group: 'genre' },
  { id: 'country', name: 'Country', group: 'genre' },
  { id: 'r-and-b', name: 'R&B', group: 'genre' },
  { id: 'electronic', name: 'Electronic', group: 'genre' },
  { id: 'lo-fi', name: 'Lo-fi', group: 'genre' },
  { id: 'jazz', name: 'Jazz', group: 'genre' },
  { id: 'classical', name: 'Classical', group: 'genre' },
  { id: 'metal', name: 'Metal', group: 'genre' },
  { id: 'folk', name: 'Folk', group: 'genre' },
  { id: 'indie', name: 'Indie', group: 'genre' },
  { id: 'latin', name: 'Latin', group: 'genre' },
  { id: 'reggae', name: 'Reggae', group: 'genre' },
  { id: 'ambient', name: 'Ambient', group: 'genre' },

  { id: 'for-videos', name: 'Background music for videos', group: 'project' },
  { id: 'for-games', name: 'Game music', group: 'project' },
  { id: 'for-film', name: 'Film scores', group: 'project' },
  { id: 'for-meditation', name: 'Meditation music', group: 'project' },
  { id: 'for-study', name: 'Study music', group: 'project' },
  { id: 'for-workout', name: 'Workout music', group: 'project' },

  { id: 'happy-music', name: 'Happy', group: 'mood' },
  { id: 'sad-music', name: 'Sad', group: 'mood' },
  { id: 'chill-music', name: 'Chill', group: 'mood' },
  { id: 'epic-music', name: 'Epic', group: 'mood' },
  { id: 'dramatic-music', name: 'Dramatic', group: 'mood' },
];

/** Section titles for the groups above (`music-landing` keys). */
export const MUSIC_GROUP_TITLES: Record<MusicPageLink['group'], string> = {
  occasion: 'Popular',
  genre: 'Genres',
  project: 'For your project',
  mood: 'Moods',
};

/** Old slugs that moved: permanent redirects in next.config.mjs. */
export const MOVED_MUSIC_PAGES: Record<string, string> = {
  'hip-hop': 'rap',
  'for-podcasts': 'podcast-intro-music',
};
